import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as personnel from '../../../../personnel'
import * as relationship from '../relationship'

export const RESOURCE = {
  payload: {
    canBeOptional: false,
    context: core.dms.models.Attribute.Id.Context.from({
      context: relationship.RESOURCE.payload.dimension.partialId,
      partialId: relationship.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description: 'Employee that is leading',
    isOptional: false,
    name: 'Leader',
    partialId: PartialId.Standard.create('leader'),
    type: {
      dimensionId: core.dms.models.Dimension.Id.from(
        personnel.RESOURCE.payload,
      ),
    },
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
